import {AccountScreens} from './screens';
import {SCREEN_CATALOG, routeForScreen} from './studentTabs';

export interface MenuItem {
  route: string;
  label: string;
  icon: string;
}

// Mesma regra do app-mobile (MenuScreen.functions.ts): entra no menu a tela
// cujo navEnabled vale exatamente 'on'. A blacksheep, por exemplo, manda
// wodList com 'false' — string, nao booleano.
const ativo = (valor?: string | null): boolean => valor === 'on';

// Ordem fixa em vez da ordem do objeto: a resposta do GraphQL nao garante
// ordem de chaves, e o menu mudaria de lugar entre carregamentos.
const ORDEM = [
  'wodList',
  'wods',
  'wodListDate',
  'schedule',
  'courses',
  'records',
  'favorites',
  'completions',
  'anthropometric',
  'timer',
] as const;

// settings.screens usa `anthropometric`, mas a rota e `anthropometrics`.
const ROTA_DA_CONFIG: Record<string, string> = {anthropometric: 'anthropometrics'};

export const buildMenuItems = (screens?: AccountScreens | null): MenuItem[] => {
  if (!screens) return [];

  return ORDEM.filter((chave) => ativo(screens[chave]?.navEnabled)).map((chave) => {
    const rota = routeForScreen(ROTA_DA_CONFIG[chave] ?? chave);
    const doCatalogo = SCREEN_CATALOG[ROTA_DA_CONFIG[chave] ?? chave];

    return {
      route: rota,
      label: doCatalogo?.label ?? chave,
      icon: doCatalogo?.icon ?? 'fa-circle',
    };
  });
};

export const nomeExibido = (usuario?: {fullName?: string | null; shortName?: string | null; email?: string | null} | null): string =>
  usuario?.fullName?.trim() || usuario?.shortName?.trim() || usuario?.email?.trim() || 'Aluno';

export const iniciaisDoNome = (nome: string): string =>
  nome
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((parte) => parte.charAt(0).toLocaleUpperCase('pt-BR'))
    .join('');
